__turbopack_context__.v({
  "badge": "CtaFinal-module__LGjAlG__badge",
  "btnPrimary": "CtaFinal-module__LGjAlG__btnPrimary",
  "btnSecondary": "CtaFinal-module__LGjAlG__btnSecondary",
  "buttonGroup": "CtaFinal-module__LGjAlG__buttonGroup",
  "ctaSection": "CtaFinal-module__LGjAlG__ctaSection",
  "footerNote": "CtaFinal-module__LGjAlG__footerNote",
  "glow": "CtaFinal-module__LGjAlG__glow",
  "subtitle": "CtaFinal-module__LGjAlG__subtitle",
  "title": "CtaFinal-module__LGjAlG__title",
});
